
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

interface FAQSectionProps {
  title?: string;
  description?: string;
  faqs?: FAQItem[];
}

export function FAQSection({
  title = "Have a Question?",
  description = "Got questions? We've answered them—no need for a 2-hour podcast episode to get to the point.",
  faqs = [
    {
      question: "What happens after I book a session?",
      answer: "After you click the \"Book Now\" button you'll be able to select a time and submit payment. We'll follow-up within 24 hours to confirm the appointment and send you the address."
    },
    {
      question: "Where are you located?",
      answer: "We're located in the Travis Heights neighborhood of Austin, TX (78704). Once you book with us we'll send you an email with the exact address and instruction on how to find us. There is a completely separate entrance for the Pod."
    },
    {
      question: "What happens to my audio/video after a recording session?",
      answer: "Following your session, we will transfer your files to a private google drive folder where you can access them. This should arrive in your inbox within 24 hours."
    },
    {
      question: "Can you edit and/or publish my podcast after recording?",
      answer: "Yes, we offer editing and post-production services at an affordable cost. Please contact us at interview@mindhack.com to request additional details. Editing services are offered at $75/episode."
    },
    {
      question: "How do I pay for the studio rental?",
      answer: "You will be presented a stripe link on the calendar booking tool. To add editing or post production services, email us at interview@mindhack.com"
    },
    {
      question: "What is the cancelation policy?",
      answer: "For a full refund please reschedule or cancel a session at least 24 hours prior to the scheduled recording. If something happens like your guest doesn't show up or you need to cancel within 24-hours we can just reschedule the appointment to a different date and time."
    },
    {
      question: "What gear and software do you use?",
      answer: <ul className="list-disc pl-6 space-y-2">
        <li>We use Blackmagic Design ATEM Mini Pro Switcher</li>
        <li>Two Shure SM7B microphones</li>
        <li>Two Canon EOS R cameras for the close-up shots and a DJI Pocket 3 for the wide shot</li>
        <li>For editing we use Descript, Capcut and Davinci Resolve</li>
      </ul>
    }
  ]
}: FAQSectionProps) {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-studio-stone">{title}</h2>
        <p className="text-lg text-center text-studio-stone/80 mb-12">{description}</p>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index + 1}`}>
                <AccordionTrigger>{faq.question}</AccordionTrigger>
                <AccordionContent>
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
